(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9965],{

/***/ 12314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/dealer",
      function () {
        return __webpack_require__(6181);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28598);
/* harmony import */ var _components_form_fields__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68143);
/* harmony import */ var _components_form_layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76817);
/* harmony import */ var _components_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98655);
/* harmony import */ var _contexts_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28798);
/* harmony import */ var _hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97859);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47392);
/* harmony import */ var _utils_helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45911);
/* harmony import */ var _utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68379);
/* harmony import */ var _utils_schemas__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73705);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46392);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82684);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75367);
/* eslint-disable @next/next/no-img-element */ 












const Dealer = (param)=>{
    let { models , content , tracking , brand , dealer , model , servicing , query  } = param;
    const campaign = (0,_contexts_index__WEBPACK_IMPORTED_MODULE_4__/* .useCampaign */ .yQ)();
    const [submitResponse, setSubmitResponse] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("");
    const [dealers, setDealers] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [dealersList, setDealersList] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [isDealer, setIsDealer] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [isModelQuery, setIsModelQuery] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [isEnquiryQuery, setIsEnquiryQuery] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [searchTerm, setSerchTerm] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)("");
    const [typeOfEnquiries, setTypeOfEnquiries] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [typeOfEnquiriesValues, setTypeOfEnquiriesValues] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)([]);
    const [showReg, setShowReg] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const [showModel, setShowModel] = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false);
    const initialValues = {
        type: "CU",
        title: "",
        first_name: "",
        last_name: "",
        email: "",
        tel: "",
        type_dropdown: "",
        type_of_enquiry: "",
        enquiry_description: "",
        subject: "",
        pvt_company_car: "",
        reg_num: "",
        model: "",
        consent: {
            user: false
        },
        is_dealer: (query === null || query === void 0 ? void 0 : query.source) === "dealer" || (query === null || query === void 0 ? void 0 : query.source) === "centre",
        dealer: "",
        dealer_name: "",
        crm_response_source: "CentreWebsite",
        source: "",
        is_lexus: brand === "lexus"
    };
    const methods = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .useForm */ .cI)({
        resolver: (0,_hookform_resolvers_yup__WEBPACK_IMPORTED_MODULE_12__/* .yupResolver */ .X)(_utils_schemas__WEBPACK_IMPORTED_MODULE_8__/* .ContactUsDealerSchema */ .r2),
        defaultValues: initialValues,
        mode: "onTouched"
    });
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (servicing) {
            if (brand === "lexus") {
                setTypeOfEnquiries(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_OLSO */ .Jv);
                setTypeOfEnquiriesValues(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_OLSO_VALUES */ .gI);
            } else {
                setTypeOfEnquiries(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_OTSO */ .Fd);
                setTypeOfEnquiriesValues(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_OTSO_VALUES */ .Ez);
            }
        } else {
            setTypeOfEnquiries(brand === "lexus" ? _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_LEXUS */ .tD : _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_TOYOTA */ .Ry);
            setTypeOfEnquiriesValues(brand === "lexus" ? _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_LEXUS_VALUES */ .pP : _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_TOYOTA_VALUES */ .eA);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (query === null || query === void 0 ? void 0 : query.model) {
            setShowModel(false);
            setIsModelQuery(true);
            methods.setValue("model", model.d4t4.id);
        }
        if (query === null || query === void 0 ? void 0 : query.enquiryType) {
            setIsEnquiryQuery(true);
            methods.setValue("type_dropdown", query === null || query === void 0 ? void 0 : query.enquiryType);
            if (methods.getValues("type_dropdown") === "new_car" || methods.getValues("type_dropdown") === "fleet_business") {
                setShowModel(true);
            }
        }
        if ((query === null || query === void 0 ? void 0 : query.comment) === "whce") {
            methods.setValue("notes", "Winter Health Checks Enquiry");
        }
    }, [
        query
    ]);
    const dropdownChanged = methods.watch("type_dropdown");
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (query.enquiryType) {
            setTypeOfEnquiriesValues(brand === "lexus" ? _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_LEXUS_VALUES */ .pP : _utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TYPE_OF_ENQUIRIES_TOYOTA_VALUES */ .eA);
            const typeOfEnquiry = methods.getValues("type_dropdown");
            const values = typeOfEnquiriesValues[typeOfEnquiry];
            if (values) {
                methods.setValue("type", values.type);
                methods.setValue("type_of_enquiry", values.type_of_enquiry);
                methods.setValue("enquiry_description", values.enquiry_description);
                methods.setValue("subject", values.subject);
                methods.setValue("pvt_company_car", values.pvt_company_car);
            }
        }
    }, [
        query,
        dropdownChanged
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (!query.enquiryType) {
            const typeOfEnquiry = methods.getValues("type_dropdown");
            if (typeOfEnquiry) {
                const values = typeOfEnquiriesValues[typeOfEnquiry];
                methods.setValue("type", values.type);
                methods.setValue("type_of_enquiry", values.type_of_enquiry);
                methods.setValue("enquiry_description", values.enquiry_description);
                methods.setValue("subject", values.subject);
                methods.setValue("pvt_company_car", values.pvt_company_car);
            }
        }
    }, [
        dropdownChanged
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (dealer) {
            var ref, ref1, ref2, ref3;
            methods.setValue("dealer", (dealer === null || dealer === void 0 ? void 0 : (ref = dealer.applications) === null || ref === void 0 ? void 0 : (ref1 = ref.NMSC) === null || ref1 === void 0 ? void 0 : ref1.externalID) ? dealer.applications.NMSC.externalID : "");
            methods.setValue("dealer_name", dealer.name);
            methods.setValue("is_dealer", true);
            if (dealer === null || dealer === void 0 ? void 0 : (ref2 = dealer.applications) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.NMSC) === null || ref3 === void 0 ? void 0 : ref3.externalID) setIsDealer(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dealer
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_10__.useEffect)(()=>{
        if (campaign.campaign) methods.setValue("campaign_code", campaign.campaign);
        if (campaign.brochure) methods.setValue("campaign_response_code", campaign.brochure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        campaign
    ]);
    const handleClick = (e)=>{
        if (brand === "lexus" && (e.target.value === "servicing" || e.target.value === "notlisted_current" || e.target.value === "parts" || e.target.value === "repair")) {
            setShowReg(true);
        } else {
            setShowReg(false);
        }
        if (e.target.value === "new_car" || e.target.value === "fleet_business") {
            const modelSet = methods.getValues("model");
            if (!modelSet) {
                setShowModel(true);
            }
        } else {
            methods.resetField("model");
            setShowModel(false);
        }
    };
    const onSubmit = async (data)=>{
        /* eslint-disable no-param-reassign */ dealersList.forEach((dealerFound)=>{
            if (dealerFound.localDealerID === data.dealer) {
                data.dealer_name = dealerFound.name;
            }
        });
        setSubmitResponse("");
        await (0,axios__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)({
            method: "post",
            url: "".concat("https://api.toyota.co.uk/forms/api", "/contact-us-dealer"),
            headers: {
                "Content-Type": "application/json"
            },
            data
        }).then(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__/* .formEvent */ .Be)({
                conversion: 1,
                name: tracking.form,
                step: "form-submit",
                variant: (data === null || data === void 0 ? void 0 : data.type_of_enquiry) || "",
                page: tracking.page
            });
            (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .closeOverlay */ .Km)(content.confirmation.title, content.confirmation.copy, setSubmitResponse);
        }).catch(()=>{
            (0,_utils_helpers_tracking__WEBPACK_IMPORTED_MODULE_7__/* .formEvent */ .Be)({
                conversion: 0,
                name: tracking.form,
                step: "form-error",
                variant: (data === null || data === void 0 ? void 0 : data.type_of_enquiry) || "",
                page: tracking.page
            });
            setSubmitResponse(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
            throw new Error(_utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .ERROR_MESSAGE */ .c9);
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ui__WEBPACK_IMPORTED_MODULE_3__/* .Nav */ .JL, {
                title: content.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormWrapper */ .n, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_layout__WEBPACK_IMPORTED_MODULE_2__/* .FormStep */ .p, {
                    subtitle: content.details.subtitle,
                    active: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_11__/* .FormProvider */ .RV, {
                        ...methods,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                            onSubmit: methods.handleSubmit(onSubmit),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .AuthFill */ .Pl, {}),
                                !isDealer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FindDealer */ .$x, {
                                    isError: "dealer" in methods.formState.errors && !dealers.length,
                                    label: "".concat(brand === "lexus" ? "Choose" : "Find", " your preferred ").concat(brand === "lexus" ? "centre" : "dealer"),
                                    infoText: "Enter your postcode/location",
                                    value: searchTerm,
                                    search: (dealersFound, term)=>{
                                        setSerchTerm(term);
                                        const dealersOptions = dealersFound.map((dealerObj)=>{
                                            return {
                                                label: dealerObj === null || dealerObj === void 0 ? void 0 : dealerObj.name,
                                                value: dealerObj === null || dealerObj === void 0 ? void 0 : dealerObj.localDealerID,
                                                name: dealerObj === null || dealerObj === void 0 ? void 0 : dealerObj.name,
                                                uuid: dealerObj === null || dealerObj === void 0 ? void 0 : dealerObj.uuid,
                                                address: dealerObj === null || dealerObj === void 0 ? void 0 : dealerObj.address
                                            };
                                        });
                                        setDealersList(dealersFound);
                                        if (dealersOptions.length) {
                                            const dealerList = (0,_utils_helpers__WEBPACK_IMPORTED_MODULE_6__/* .removeDuplicate */ .be)(dealersOptions, "value");
                                            setDealers(dealerList);
                                            methods.setValue("dealer", dealerList[0].value, {
                                                shouldValidate: true
                                            });
                                        }
                                    }
                                }),
                                dealers.length > 0 && !isDealer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .ClosestDealers */ .FF, {
                                    label: "".concat(brand === "lexus" ? "Please select a Lexus Centre" : "Nominated Dealers"),
                                    helper: "".concat(brand === "lexus" ? "List displays the closest centre to your postcode." : "List displays the closest dealer to your postcode."),
                                    dealers: dealers
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Title */ .Dx, {
                                    optional: true
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .FirstName */ .SW, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .LastName */ .uQ, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Email */ .GT, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Tel */ .ki, {
                                    optional: true
                                }),
                                !isEnquiryQuery && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .DropDown */ .vb, {
                                    label: "".concat(brand === "lexus" ? "Select Enquiry Type" : "What would you like to discuss?"),
                                    name: "type_dropdown",
                                    options: typeOfEnquiries,
                                    onChange: handleClick
                                }),
                                showReg && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .VehicleRegNo */ .Mb, {
                                    optional: true
                                }),
                                showModel && !isModelQuery && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Models */ .kk, {
                                    models: models,
                                    label: "Model of interest"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Comments */ .HW, {
                                    optional: true,
                                    name: "notes",
                                    characterLimit: 1500,
                                    label: "".concat(brand === "lexus" ? "Enquiry details" : "Let us know if you have any specific requirements.")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .MarketingConsent */ .nb, {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_form_fields__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    type: "submit",
                                    submitResponse: submitResponse,
                                    children: content.details.submit
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
Dealer.whyDidYouRender = true;
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (Dealer);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7409,1850,9595,9516,8655,4817,9774,2888,179], function() { return __webpack_exec__(12314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);